import React, { useState, useEffect } from 'react'
import { Modal, Button } from 'antd'
import ContactUS from '../../../components/ContactUS'
import personalVipIcon from '../../../../images/icon_vip_personal.png'
import MobileVipGuide from '../MobileVipGuide'
import styles from './index.module.css'

interface VipGuardProps {
  open: boolean
  onClose: () => void
  /** 保留以兼容旧调用方；若未传则点击"去手机端开通"打开内置的手机端指引弹窗 */
  onBuyVip?: () => void
  onTrack?: (actionType: string) => void
}

const VipGuard: React.FC<VipGuardProps> = ({
  open,
  onClose,
  onBuyVip,
  onTrack
}) => {
  const [guideVisible, setGuideVisible] = useState(false)

  useEffect(() => {
    if (open) {
      if (onTrack) onTrack('showPop')
    }
  }, [open, onTrack])

  const handleMobileClick = () => {
    if (onBuyVip) {
      onBuyVip()
      return
    }
    setGuideVisible(true)
  }

  return (
    <>
      {renderModal(open, onClose, handleMobileClick, onTrack)}
      <MobileVipGuide
        open={guideVisible}
        onClose={() => setGuideVisible(false)}
        onGoApp={() => onTrack?.('goApp')}
      />
    </>
  )
}

const renderModal = (
  open: boolean,
  onClose: () => void,
  onMobileClick: () => void,
  onTrack?: (actionType: string) => void
) => (
  <Modal
    open={open}
    title={null}
    footer={null}
    onCancel={onClose}
    centered
    width={400}
    styles={{ body: { textAlign: 'center', padding: '40px 24px' } }}
  >
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 8,
        marginBottom: 8
      }}
    >
      <img
        src={personalVipIcon}
        alt="个人会员"
        style={{ height: 22, width: 'auto' }}
      />
      <h3 style={{ fontSize: 18, fontWeight: 600, color: '#333', margin: 0 }}>
        开通个人会员
      </h3>
    </div>
    <p style={{ fontSize: 14, color: '#666', marginBottom: 24 }}>
      个人空间 Web 端需要个人会员才可使用全部功能
    </p>
    <div style={{ display: 'flex', gap: 12 }}>
      <Button
        size="large"
        className={styles.defaultBtn}
        onClick={onMobileClick}
        style={{ flex: 1 }}
      >
        去手机端开通
      </Button>
      <span
        onClick={() => {
          if (onTrack) onTrack('contactUs')
          onClose()
        }}
        style={{ flex: 1, display: 'flex' }}
      >
        <ContactUS fromPage="my_space_vip_guard" style={{ flex: 1 }}>
          <Button
            type="primary"
            size="large"
            style={{
              width: '100%',
              background: '#0070F4',
              borderColor: '#0070F4'
            }}
          >
            联系客服开通
          </Button>
        </ContactUS>
      </span>
    </div>
  </Modal>
)

export default VipGuard
